import { QueryConfig } from "store/utils/query-config";

export const scheduledMessagesDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["schedule.time"]
  }
};
